/**
 * Vue injection utilities for global fields
 * Provides type-safe access to the global FieldRepository via Vue's provide/inject
 */
import { inject } from "vue";
/**
 * Injection key for the global FieldRepository
 */
export const FIELDS_INJECTION_KEY = Symbol("global-fields");
/**
 * Composable to access the global FieldRepository
 * Use this in any component that needs access to fields
 */
export function useFields() {
    const fields = inject(FIELDS_INJECTION_KEY);
    if (!fields) {
        throw new Error("Fields not provided. Ensure FieldsProvider is initialized in App.vue");
    }
    return fields;
}
